import classes from "./styles.module.css"
import {Box, Button, Dialog, DialogContent, IconButton, Tooltip} from "@mui/material";
import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import {path} from "../../../routes";

const RATIO_OPTIONS = ['9:16', '16:9', '4:3'];
const isPortrait = (r) => r === '9:16';
const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
const RADISSON_BLU_ORG_ID = 'AC9D7FD5-E333-4B1E-9043-4697568313B7';
const VIENNA_HOUSE_ORG_ID = '62BDEE7F-9CE9-41BE-A80C-EF69F045D56C';
// "Legacy" hotely — URL zachovat v dokumentovaném dlouhém formátu s orgID.
// Nové orgy dostávají krátký URL bez orgID (backend řeší přes device.id).
const LEGACY_ORG_IDS = [
    HOLIDAY_INN_ORG_ID,
    RADISSON_BLU_ORG_ID,
    VIENNA_HOUSE_ORG_ID,
    '82BB6005-2C25-4EB9-A6CC-DB8BFB4A3C70', // Zimní stadion Nymburk
    '7A67452A-F5D4-430D-B283-8A93B28B425C', // Fairmont Golden Prague
].map(s => s.toUpperCase());

const Row_org_device =(props)=>{
    const [data, setData] = useState(props.data);
    const [demoOpen, setDemoOpen] = useState(false);
    // Výchozí podle typu zařízení: Displej = 4:3, Kiosk = 9:16
    const getInitialDemoRatio = () => {
        const deviceGroup = Number(props.data?.device_group);
        return deviceGroup === 1 ? '4:3' : '9:16';
    };
    const [demoRatio, setDemoRatio] = useState(getInitialDemoRatio());
    
    // Aktualizovat data když se změní props
    useEffect(() => {
        setData(props.data);
    }, [props.data]);

const deleteFn = () => {
        if (props.onDeleteRequest) {
            props.onDeleteRequest(props.data);
        } else if (props.delete) {
            props.delete(props.data.id);
        }
    };

    const editFn = () => {
        if (props.onEdit) {
            props.onEdit(data);
        }
    }

    const copyToClipboard = async (text) => {
        try {
            const value = String(text);
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                alert('Link copied to clipboard.');
                return true;
            }
            const ta = document.createElement('textarea');
            ta.value = value;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            if (ok) {
                alert('Link copied to clipboard.');
            }
            return ok;
        } catch (e) {
            console.error('Copy failed:', e);
            return false;
        }
    };
    const getDisplayBaseUrl = (useAdminPath = false) => {
        if (typeof window === 'undefined') return useAdminPath ? 'https://kiosk.csgcontrols.cz/admin/' : 'https://kiosk.csgcontrols.cz/';
        const origin = (window.location.origin || '').replace(/\/$/, '');
        return useAdminPath ? `${origin}/admin/` : `${origin}/`;
    };

    /** Stejná logika jako v UsersDisplays/Row_display – aby admin i user Holiday Inn viděli stejné URL. */
    const getHolidayInnUrlParams = (rowData) => {
        const has = (v) => v != null && v !== '';
        if (has(rowData.url_id)) {
            const urlId = String(rowData.url_id);
            const urlRoom = has(rowData.url_room) ? String(rowData.url_room) : null;
            // Holiday Inn URL conventions (per referenční XLSX "Odkaz zařízení"):
            // - id=1, 9: jen ?id=N
            // - id=11&room=X: meeting room, BEZ orgID
            // - id=12, 13: combined totem A-D / E-F, S orgID
            // - id=3: recepce totem, S orgID
            // - id=101&room=X: individual virtual room, BEZ orgID
            const urlOrgID =
                (urlId === '3' || urlId === '12' || urlId === '13')
                    ? (has(rowData.url_orgID) ? String(rowData.url_orgID) : HOLIDAY_INN_ORG_ID)
                    : null;
            return { urlId, urlRoom, urlOrgID };
        }
        const desc = (rowData.description || '').toLowerCase().trim();
        const id = rowData.id;
        if (desc.includes('restaurace') && (desc.includes('menu') || !desc.includes('specialit'))) return { urlId: '1', urlRoom: null, urlOrgID: null };
        if (desc.includes('restaurace') && desc.includes('specialit')) return { urlId: '9', urlRoom: null, urlOrgID: null };
        if (desc.includes('recepce') || (desc.includes('obrazovka') && desc.includes('výšku'))) return { urlId: '3', urlRoom: null, urlOrgID: HOLIDAY_INN_ORG_ID };
        if (desc.includes('a - d') || desc.includes('a-d')) return { urlId: '12', urlRoom: null, urlOrgID: null };
        if (desc.includes('e - f') || desc.includes('e-f')) return { urlId: '13', urlRoom: null, urlOrgID: null };
        if (desc.includes('meeting room a') || desc === 'meeting room a') return { urlId: '11', urlRoom: '23', urlOrgID: null };
        if (desc.includes('meeting room b')) return { urlId: '11', urlRoom: '24', urlOrgID: null };
        if (desc.includes('meeting room c')) return { urlId: '11', urlRoom: '25', urlOrgID: null };
        if (desc.includes('meeting room d')) return { urlId: '11', urlRoom: '26', urlOrgID: null };
        if (id === 23) return { urlId: '11', urlRoom: '23', urlOrgID: null };
        if (id === 24) return { urlId: '11', urlRoom: '24', urlOrgID: null };
        if (id === 25) return { urlId: '11', urlRoom: '25', urlOrgID: null };
        if (id === 26) return { urlId: '11', urlRoom: '26', urlOrgID: null };
        return { urlId: Number(rowData.device_group) === 1 ? '101' : '100', urlRoom: String(rowData.id), urlOrgID: null };
    };

    /** Jedinečná URL pro tento display/kiosk. Pro Holiday Inn stejné URL jako v Users/Displays (podle url_id / popisu). */
    const buildRuntimeUrl = (extraParams = {}) => {
        const orgId = (props.data.cOrganization_id || '').toString().trim().toUpperCase();
        const isHolidayInn = orgId === HOLIDAY_INN_ORG_ID.toUpperCase();
        const isRadissonBlu = orgId === RADISSON_BLU_ORG_ID.toUpperCase();
        const dg = Number(props.data.device_group);
        // room = url_room (pokud nastavený) NEBO device.id. Záměrně přeskakujeme
        // roomGroup — to bývá v DB textový label (např. "A-D", "E-F", "O"),
        // ne číslo room ID. Použít label v URL by vyrobilo nevalidní URL
        // (?room=A-D místo ?room=8).
        const room = props.data.url_room != null && String(props.data.url_room).trim() !== ''
            ? String(props.data.url_room).trim()
            : String(props.data.id);

        if (isHolidayInn) {
            // /admin/ prefix konzistentně se zbytkem orgů + referenční XLSX
            // ("Kiosky - web aplikace ...", Odkaz zařízení).
            const base = getDisplayBaseUrl(true);
            const { urlId, urlRoom, urlOrgID } = getHolidayInnUrlParams(props.data);
            const params = new URLSearchParams();
            params.set('id', urlId);
            if (urlRoom) params.set('room', urlRoom);
            if (urlOrgID) params.set('orgID', urlOrgID);
            let url = `${base}?${params.toString()}`;
            if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
            return url;
        }
        if (isRadissonBlu) {
            const base = getDisplayBaseUrl(true);
            const id = dg === 1 ? '5' : '7';
            if (dg === 2) {
                let url = `${base}?id=${id}`;
                if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
                return url;
            }
            let url = `${base}?id=${id}&room=${room}`;
            if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
            return url;
        }
        // Vienna House (Plzeň): kiosk parametr odvodit z konkrétního zařízení.
        //   id=40 "Kiosk - hall"      → kiosk=1 (dolní)
        //   id=41 "Kiosk - 1st floor" → kiosk=2 (horní)
        // Pokud DB má url_kiosk, použít ho přednostně.
        const isViennaHouse = orgId === VIENNA_HOUSE_ORG_ID.toUpperCase();
        if (isViennaHouse && dg === 2) {
            const base = getDisplayBaseUrl(true);
            const desc = String(props.data.description || '').toLowerCase();
            let kiosk = '2';
            if (props.data.url_kiosk != null && String(props.data.url_kiosk).trim() !== '') {
                kiosk = String(props.data.url_kiosk).trim();
            } else if (Number(props.data.id) === 40 || desc.includes('hall') || desc.includes('dolní')) {
                kiosk = '1';
            } else if (Number(props.data.id) === 41 || desc.includes('1st floor') || desc.includes('horní')) {
                kiosk = '2';
            }
            let url = `${base}?id=6&kiosk=${kiosk}`;
            if (extraParams.demoRatio) url += `&demoRatio=${encodeURIComponent(extraParams.demoRatio)}`;
            return url;
        }

        const base = getDisplayBaseUrl(true);
        const has = (v) => v != null && v !== '';
        const isLegacy = LEGACY_ORG_IDS.includes(orgId);
        // Pro non-legacy orgy: id = orgShortId (per-org číselný identifikátor),
        // takže všechna zařízení v org sdílí stejné id a liší se jen v room.
        // Pro legacy nebo když shortId není dostupný: fallback na typ-zobrazení (100/101).
        const idParam = has(props.data.url_id)
            ? String(props.data.url_id)
            : (!isLegacy && has(props.data.orgShortId)
                ? String(props.data.orgShortId)
                : (dg === 1 ? '101' : '100'));
        // Pro nové orgy preferuj localId (per-org sekvence 1, 2, 3...).
        const localRoom = (!isLegacy && has(props.data.localId)) ? String(props.data.localId) : null;
        // Priorita pro room:
        //   - LEGACY orgy: url_room (dle reference XLSX) → device.id
        //   - NON-LEGACY orgy: localId (per-org sekvence) → url_room → device.id
        //     (localId má přednost — aby všechna zařízení v jedné org měla room
        //      1, 2, 3 a v URL byl krátký, konzistentní formát.)
        let roomShort;
        let roomIsLocalId;
        if (!isLegacy && localRoom != null) {
            roomShort = localRoom;
            roomIsLocalId = true;
        } else if (has(props.data.url_room)) {
            roomShort = String(props.data.url_room);
            roomIsLocalId = localRoom != null && roomShort === localRoom;
        } else if (localRoom != null) {
            roomShort = localRoom;
            roomIsLocalId = true;
        } else {
            roomShort = room;
            roomIsLocalId = false;
        }
        const params = new URLSearchParams();
        if (isLegacy) {
            params.set('room', room);
            if (has(props.data.url_orgID)) params.set('orgID', String(props.data.url_orgID));
            else if (props.data.cOrganization_id) params.set('orgID', String(props.data.cOrganization_id));
            params.set('id', idParam);
        } else {
            // Nové orgy: id = orgShortId (per-org), room = localId. orgID v URL NIKDY —
            // backend dohledá org podle shortId přes /resolveOrgDevice.
            params.set('id', idParam);
            params.set('room', roomShort);
        }
        if (extraParams.demoRatio) params.set('demoRatio', extraParams.demoRatio);
        return `${base}?${params.toString()}`;
    };

    const copy = async () => {
        await copyToClipboard(buildRuntimeUrl());
    };

    const openDemo = () => setDemoOpen(true);

    // Při otevření dema načíst poměr stran z nastavení zařízení (9:16 / 16:9 / 4:3)
    useEffect(() => {
        if (!demoOpen || !data?.id) return;
        const deviceGroup = Number(data?.device_group);
        
        // Pro displeje (device_group === 1) vždy použít 4:3, bez ohledu na nastavení
        if (deviceGroup === 1) {
            setDemoRatio('4:3');
            return;
        }
        
        // Pro kiosky načíst z nastavení nebo použít podle orientation
        let cancelled = false;
        const load = async () => {
            try {
                const resp = await axios.get(`${path}/getDeviceSettings/${data.id}`);
                const r = resp.data?.settings?.demoRatio;
                if (cancelled) return;
                if (typeof r === 'string' && RATIO_OPTIONS.includes(r)) {
                    setDemoRatio(r);
                } else {
                    // Fallback podle orientation: landscape = 16:9, portrait = 9:16
                    if (Number(data?.orientation) === 2) {
                        setDemoRatio('16:9'); // Kiosk landscape
                    } else {
                        setDemoRatio('9:16'); // Kiosk portrait
                    }
                }
            } catch (_) {
                if (!cancelled) {
                    // Fallback při chybě: podle orientation
                    setDemoRatio(Number(data?.orientation) === 2 ? '16:9' : '9:16');
                }
            }
        };
        load();
        return () => { cancelled = true; };
    }, [demoOpen, data?.id, data?.orientation, data?.device_group]);

    useEffect(() => {
        if (!demoOpen) return;
        const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
        const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
        const expectedWidth = isPortrait(demoRatio) ? (vh * 0.95 * 9 / 16) : demoRatio === '16:9' ? Math.min(vw * 0.95, vh * 0.95 * 16 / 9) : Math.min(vw * 0.95, vh * 0.95 * 4 / 3);
        console.log('[Kiosk Demo – admin Zobrazovače]', {
            demoRatio: demoRatio || '(nevybráno)',
            url: buildRuntimeUrl({ demoRatio }),
            viewport: `${vw}×${vh}`,
            očekávanéRozlišeníKontejneru: `${Math.round(expectedWidth)}×${Math.round(vh * 0.95)}`,
        });
    }, [demoOpen, demoRatio]);

    const colCount = props.showOrg ? 4 : 3;
    const cellDataCls = (i, isAct) => {
        const isFirst = i === 0;
        const isLast = i === colCount - 1;
        return `${classes.cellData} ${isFirst ? classes.cellColFirst : ''} ${isLast ? classes.cellColLast : ''} ${props.isLastRow ? classes.cellRowLast : ''} ${isAct ? classes.columnAct : classes.column}`;
    };

    // "Virtuální" místnosti — existují v cDevice (lze pro ně naplánovat
    // meeting), ale nemají fyzický displej. URL tlačítko nedává smysl
    // ukazovat — žádné zařízení tam není.
    const isVirtualRoom = (() => {
        const orgUpper = (data.cOrganization_id || '').toString().trim().toUpperCase();
        const desc = (data.description || '').toLowerCase().trim();
        if (orgUpper === HOLIDAY_INN_ORG_ID.toUpperCase()) {
            return ['meeting room e', 'meeting room f', 'meeting room pop up', 'orangerie', 'foyer'].includes(desc);
        }
        if (orgUpper === VIENNA_HOUSE_ORG_ID.toUpperCase()) {
            // Angelo Plzeň — všechny meeting roomy (Opal A-D, Restaurace,
            // Safir, Smaragd, Topaz) sdílí přes id=6&kiosk=... pohled, samy
            // fyzický displej nemají.
            return ['opal a', 'opal b', 'opal c', 'opal d', 'restaurace', 'safir', 'smaragd', 'topaz'].includes(desc);
        }
        return false;
    })();

    // _synthetic = pseudo-zařízení injektnutá frontendem (Holiday Inn sdílené
    // screeny — Restaurace menu/spec, Recepce totem). Neexistují v cDevice
    // takže Upravit/Odstranit by selhalo. Zůstává jen URL tlačítko.
    const isSynthetic = Boolean(data._synthetic);

    const actButtons = (
        <>
            {!isSynthetic && (
                <Button onClick={editFn} color="primary" variant="outlined">Upravit</Button>
            )}
            {!isVirtualRoom && (
                <Tooltip title={buildRuntimeUrl()} placement="top">
                    <span><Button onClick={()=>copy()} color="primary" variant="outlined">URL</Button></span>
                </Tooltip>
            )}
            {!isSynthetic && (
                <Button onClick={()=>deleteFn()} color="primary" variant="outlined">Odstranit</Button>
            )}
        </>
    );

    const rowContent = props.renderAsGridRow ? (
        <div style={{ display: 'contents' }}>
            {props.showOrg && <div className={cellDataCls(0, false)}>{data.organizationName || data.cOrganization_id || '—'}</div>}
            <div className={cellDataCls(props.showOrg ? 1 : 0, false)}>{data.description}</div>
            <div className={cellDataCls(props.showOrg ? 2 : 1, false)}>{data.device_group == 1 ? "Displej" : "Kiosk"}</div>
            <div className={cellDataCls(colCount - 1, true)}>{actButtons}</div>
        </div>
    ) : (
        <div className={classes.columns} style={props.gridColumns ? { gridTemplateColumns: props.gridColumns } : (props.showOrg ? { gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(200px, auto)' } : undefined)}>
            {props.showOrg && <div className={classes.column}>{data.organizationName || data.cOrganization_id || '—'}</div>}
            <div className={classes.column}>{data.description}</div>
            <div className={classes.column}>{data.device_group == 1 ? "Displej" : "Kiosk"}</div>
            <div className={classes.columnAct}>{actButtons}</div>
        </div>
    );

    return <>
    {rowContent}

    <Dialog
        open={demoOpen}
        onClose={() => setDemoOpen(false)}
        maxWidth={false}
        PaperProps={{
            sx: {
                borderRadius: '12px',
                maxHeight: '95vh',
                overflow: 'hidden'
            }
        }}
    >
        <DialogContent
            sx={{
                p: 0,
                position: 'relative',
                backgroundColor: '#111',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 320,
                overflow: 'hidden'
            }}
        >
            <IconButton
                aria-label="close"
                onClick={() => setDemoOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: 'white',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box
                sx={{
                    aspectRatio: demoRatio === '9:16' ? '9/16' : demoRatio === '16:9' ? '16/9' : '4/3',
                    boxSizing: 'border-box',
                    flexShrink: 0,
                    height: '95vh',
                    ...(isPortrait(demoRatio)
                        ? { width: 'calc(95vh * 9 / 16)' }
                        : demoRatio === '16:9'
                            ? { width: 'min(100%, calc(95vh * 16 / 9))' }
                            : { width: 'min(100%, calc(95vh * 4 / 3))' }
                    )
                }}
            >
                <iframe
                    title={`Demo ${data.description || data.id}`}
                    src={buildRuntimeUrl({ demoRatio })}
                    key={`${buildRuntimeUrl({ demoRatio })}`}
                    allow="fullscreen"
                    allowFullScreen
                    style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
                />
            </Box>
        </DialogContent>
    </Dialog>
    </>
}
export default Row_org_device;